module.exports = __webpack_public_path__ + "static/media/onto.a80ced59.svg";